import { Box, Typography } from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import RadioButtonUncheckedIcon from "@mui/icons-material/RadioButtonUnchecked";
import { Field } from "../../types/field";

interface FieldListItemProps {
  field: Field;
  onToggle: (id: string) => void;
}

const FieldListItem = ({ field, onToggle }: FieldListItemProps) => {
  return (
    <Box
      onClick={() => onToggle(field.id)}
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        padding: "12px 26px 12px 16px",
        backgroundColor: field.selected ? "rgba(0, 128, 128, 0.08)" : "white",
        borderBottom: field.selected
          ? "1px solid rgba(0, 128, 128, 0.3)"
          : "1px solid rgba(0, 0, 0, 0.12)",
        borderTop: field.selected ? "1px solid rgba(0, 128, 128, 0.3)" : "none",
        cursor: "pointer",
        transition: "all 0.2s",
        "&:hover": {
          backgroundColor: field.selected
            ? "rgba(0, 128, 128, 0.12)"
            : "rgba(0, 0, 0, 0.04)",
        },
      }}
    >
      <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
        {field.selected ? (
          <CheckCircleIcon sx={{ color: "primary.main", fontSize: 20 }} />
        ) : (
          <RadioButtonUncheckedIcon
            sx={{ color: "rgba(0, 0, 0, 0.26)", fontSize: 20 }}
          />
        )}
        <Typography
          variant="body2"
          sx={{
            fontWeight: field.selected ? 600 : 400,
            color: field.selected ? "primary.main" : "text.primary",
          }}
        >
          {field.name}
        </Typography>
      </Box>
      <Typography
        variant="body2"
        sx={{
          color: "text.secondary",
          fontWeight: 500,
        }}
      >
        {field.count}
      </Typography>
    </Box>
  );
};

export default FieldListItem;
